import 'src/lang/i18n'
import App from 'src/App'
import React from 'react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import { Reset } from 'styled-reset'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { Provider } from 'react-redux'
import store from 'src/store/store'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID
const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY

root.render(
  <Provider store={store}>
    {/*<React.StrictMode>*/}
    <GoogleReCaptchaProvider reCaptchaKey={`${RECAPTCHA_KEY}`}>
      <GoogleOAuthProvider clientId={`${CLIENT_ID}`}>
        <Reset />
        <App />
      </GoogleOAuthProvider>
    </GoogleReCaptchaProvider>
    {/*</React.StrictMode>*/}
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
